import {
  CustomerEmailChangeStateSchema, CustomerEmailChangeRequestSchema,
  CustomerEmailChangeConfirmSchema, CustomerEmailChangeCancelSchema,
  CustomerEmailChangeCompletedSchema,
  type CustomerEmailChangeRequest, type CustomerEmailChangeConfirm
} from '@inktap/contracts/customer-account';
import { request } from './api';

export const readEmailChange = async (signal: AbortSignal) =>
  CustomerEmailChangeStateSchema.parse(await request<unknown>('/auth/email-change', { signal }));
export const requestEmailChange = async (body: CustomerEmailChangeRequest, signal: AbortSignal) =>
  CustomerEmailChangeStateSchema.parse(await request<unknown>('/auth/email-change/request', {
    method: 'POST', body: JSON.stringify(CustomerEmailChangeRequestSchema.parse(body)), signal
  }));
export const confirmEmailChange = async (body: CustomerEmailChangeConfirm, signal: AbortSignal) =>
  CustomerEmailChangeCompletedSchema.parse(await request<unknown>('/auth/email-change/confirm', {
    method: 'POST', body: JSON.stringify(CustomerEmailChangeConfirmSchema.parse(body)), signal
  }));
export const cancelEmailChange = async (intentId: string, signal: AbortSignal) =>
  CustomerEmailChangeStateSchema.parse(await request<unknown>('/auth/email-change/cancel', {
    method: 'POST', body: JSON.stringify(CustomerEmailChangeCancelSchema.parse({ intentId })), signal
  }));
